// Data-driven hourly budgets (plain JS)

export const FREELANCER_HOURLY_BUDGETS = {
  basic: {
    USD: [2, 8], GBP: [2, 5], EUR: [2, 6], AUD: [2, 8], CAD: [2, 8], NZD: [3, 10], SGD: [3, 10], HKD: [16, 65], INR: [100, 400]
  },
  moderate: {
    USD: [8, 15], GBP: [5, 10], EUR: [6, 12], AUD: [8, 15], CAD: [8, 15], NZD: [10, 20], SGD: [10, 20], HKD: [65, 115], INR: [400, 750]
  },
  standard: {
    USD: [15, 25], GBP: [10, 15], EUR: [12, 18], AUD: [15, 25], CAD: [15, 25], NZD: [20, 30], SGD: [20, 30], HKD: [115, 200], INR: [750, 1300]
  },
  skilled: {
    USD: [25, 50], GBP: [18, 36], EUR: [18, 36], AUD: [25, 50], CAD: [25, 50], NZD: [30, 60], SGD: [30, 60], HKD: [200, 400], INR: [1300, 2500]
  },
  // expert: {
  //   // Expert is >50 category: treat values as "base" for min; avg = base*1.5; max = base*2
  //   USD: [50, 100], GBP: [36, 90], EUR: [36, 72], AUD: [50, 100], CAD: [50, 100], NZD: [60, 100], SGD: [60, 100], HKD: [400, 800], INR: [2500, 26000]
  // }
};

/**
 * preset: 'lowest' | 'average' | 'highest'
 * For 'expert' tier we apply expert rule: min = base, avg = Math.round(base*1.5), max = Math.round(base*2)
 */
export function getHourlyPresetValue(min, max, preset, tier = null) {
  if (preset === 'lowest') return Math.round(min * 100) / 100;
  if (preset === 'highest') return Math.round(max * 100) / 100;

  if (tier === 'expert') {
    // prefer base as min; compute average using base * 1.5
    const base = min;
    return Math.ceil(base * 1.5 * 100) / 100;
  }

  const avg = (min + max) / 2;
    return Math.ceil(avg * 100) / 100;
  }

export function getHourlyRange(tier, currency) {
  const tierMap = FREELANCER_HOURLY_BUDGETS[tier];
  if (!tierMap) return null;
  const rng = tierMap[currency];
  return Array.isArray(rng) ? rng : null;
}